module.exports = __webpack_public_path__ + "img/fenXi.59a49c43.svg";